import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SettingsService } from '../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, MaterialModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})

export class LoginComponent implements OnInit {

  valForm: FormGroup;
  disabledButton: boolean = false;
  hide: boolean = true;
  role: any;
  showSpinner: boolean = false;

  constructor(fb: FormBuilder, public snackBar: MatSnackBar, private router: Router, public settings: SettingsService, private change: ChangeDetectorRef) {

    this.valForm = fb.group({
      'username': ['', Validators.compose([Validators.required, CustomValidators.email])],
      'password': ['', Validators.compose([Validators.required])]
    });


  }

  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

  ngOnInit() {

    this.setRandomBackground();
    this.settings.verify_out();
    this.change.detectChanges();

  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    this.randomImage = this.images[randomIndex];
  }

  async submitForm($ev: any, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      try {
        this.showSpinner = true;
        value.investor_portal = true;

        const bd: any = await this.settings.get_query(2, '/cliente-inversionista/login/', value, true);
        var body_data: any = bd._body;
        var data = body_data.info.datos;

        switch (bd.status) {
          case 200:


            localStorage.setItem('token', data.token);
            localStorage.setItem('role', data.role);
            localStorage.setItem('user_id', data.user_id);

            this.router.navigateByUrl('home');
          break;
          default:
            this.showSpinner = false;
            break;
        }

      } catch (bd: any) {
        console.log("error", bd)
        this.showSpinner = false;
        switch (bd.status) {
          case 500:
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

            break;

          case 400:
            this.snackBar.open('Ocurrió un error, verifica que el email ingresado y la contraseña esten correctas', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
            this.valForm.controls['password'].setErrors({ invalid: true });
            break;
          default:
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

            break;
        }
      }
    }
  }

  simulacion() {
    this.router.navigate(['/simulacion']);
  }
  
  


}